export const fieldMappingGoods: {
  [backendField: string]: { columnKey: string; label: string };
} = {
  name: {
    columnKey: 'product_name',
    label: 'Названия товара'
  },
  barcode: { columnKey: 'barcode', label: 'Штрих-код' },
  'ware_house.name': {
    columnKey: 'warehouse',
    label: 'Склад'
  },
  'currency.name.ru': {
    columnKey: 'currency',
    label: 'Валюта'
  },
  'payment_order.name.ru': {
    columnKey: 'payment_procedure',
    label: 'Процедура оплаты'
  },
  'nomenclature.measure_unit.name.ru': {
    columnKey: 'unit',
    label: 'Единица Измерения'
  },
  'legal_entity.name': {
    columnKey: 'branch',
    label: 'Филиал'
  },
  'supplier.name': {
    columnKey: 'supplier',
    label: 'Поставщик'
  },
  'category.name.ru': {
    columnKey: 'category',
    label: 'Категория'
  },

  quantity_in: {
    columnKey: 'quantity',
    label: 'Количество'
  },
  quantity: { columnKey: 'remainder', label: 'Остаток' },

  price_in: {
    columnKey: 'incoming_price',
    label: 'Цена поступления'
  },
  price_whosale: {
    columnKey: 'wholesale_price',
    label: 'Оптовая цена'
  },
  price: {
    columnKey: 'retail_price',
    label: 'Цена разницы'
  },
  is_vat: { columnKey: 'apply', label: 'Применить НДС' },
  'price_in*quantity': {
    columnKey: 'total_price_received',
    label: 'Итоговая цена поступления'
  },
  'price*quantity': {
    columnKey: 'total_price',
    label: 'Итоговая цена'
  },

  date_created: {
    columnKey: 'creation_date',
    label: 'Дата создания'
  }
};

export const fieldMappingInvoice: {
  [backendField: string]: { columnKey: string; label: string };
} = {
  invoice_number: {
    columnKey: 'invoice',
    label: '№ Накладной'
  },
  invoice_date: { columnKey: 'invoice_date', label: 'Дата Накладной' },
  'supplier.name': {
    columnKey: 'supplier',
    label: 'Поставщик'
  },
  'legal_entity.name': {
    columnKey: 'branch',
    label: 'Филиал'
  },
  'ware_house.name': {
    columnKey: 'warehouse',
    label: 'Склад'
  },
  'currency.name.ru': {
    columnKey: 'currency',
    label: 'Валюта'
  },
  'invoice_type.name.ru': {
    columnKey: 'type',
    label: 'Тип'
  },
  'payment_order.name.ru': {
    columnKey: 'payment_procedure',
    label: 'Порядок оплаты'
  },
  date_created: {
    columnKey: 'creation_date',
    label: 'Дата создания'
  },

  maturity_date: {
    columnKey: 'purchase_date',
    label: 'Дата погашения'
  },

  'employee.first_name': {
    columnKey: 'employee_opened_purchase',
    label: 'Сотрудник, открывший Закуп'
  },
  'closed_employee.first_name': {
    columnKey: 'employee_closed_purchase',
    label: 'Сотрудник, закрывший Закуп'
  }
};

export const fieldMappingSale: {
  [backendField: string]: { columnKey: string; label: string };
} = {
  'product.name': {
    columnKey: 'product_name',
    label: 'Названия товара'
  },
  'product.barcode': { columnKey: 'barcode', label: 'Штрих-код' },
  'product.ware_house.name': {
    columnKey: 'warehouse',
    label: 'Склад'
  },
  'currency.name.ru': {
    columnKey: 'currency',
    label: 'Валюта'
  },
  'product.nomenclature.measure_unit.name.ru': {
    columnKey: 'unit',
    label: 'Единица Измерения'
  },
  'legal_entity.name': {
    columnKey: 'supplier',
    label: 'Поставщик'
  },
  'user.first_name': {
    columnKey: 'buyyer',
    label: 'Покупатель'
  },

  'category.name.ru': {
    columnKey: 'category',
    label: 'Категория'
  },

  price_in: {
    columnKey: 'purchase_price',
    label: 'Цена закуп'
  },

  quantity: {
    columnKey: 'quantity',
    label: 'Количество'
  },

  price: {
    columnKey: 'sales_price',
    label: 'Цена продажи'
  },
  payment_amount: {
    columnKey: 'paid',
    label: 'Оплачено'
  },

  payment_difference: {
    columnKey: 'discrepancy',
    label: 'Расхождение'
  },

  total_payment_amount: {
    columnKey: 'total_payment_price',
    label: 'Итого сумма оплаты'
  },

  date_create: {
    columnKey: 'date',
    label: 'Дата создания'
  },
  date_sync: {
    columnKey: 'date_synchronization',
    label: 'Дата синхронизации'
  }
};

export const fieldMappingReturn: {
  [backendField: string]: { columnKey: string; label: string };
} = {
  'product.name': {
    columnKey: 'product_name',
    label: 'Названия товара'
  },
  'product.barcode': { columnKey: 'barcode', label: 'Штрих-код' },
  'product.nomenclature.measure_unit.name.ru': {
    columnKey: 'unit',
    label: 'Единица Измерения'
  },
  'currency.name.ru': {
    columnKey: 'currency',
    label: 'Валюта'
  },
  income_amount: { columnKey: 'quantity', label: 'Количество' },

  'product.ware_house.name': {
    columnKey: 'warehouse_name',
    label: 'Склад'
  },

  'legal_entity.name': {
    columnKey: 'supplier',
    label: 'Поставщик'
  },

  date_created: {
    columnKey: 'creation_date',
    label: 'Дата создания'
  }
};

export const fieldMappingRemainder: {
  [backendField: string]: { columnKey: string; label: string };
} = {
  name: {
    columnKey: 'product_name',
    label: 'Названия товара'
  },
  barcode: { columnKey: 'barcode', label: 'Штрих-код' },

  'currency.name.ru': {
    columnKey: 'currency',
    label: 'Валюта'
  },
  'nomenclature.measure_unit.name.ru': {
    columnKey: 'unit',
    label: 'Единица Измерения'
  },

  'nomenclature.category.name.ru': {
    columnKey: 'category',
    label: 'Категория'
  },

  quantity: { columnKey: 'quantity', label: 'Количество' },

  price_in: {
    columnKey: 'cost_in',
    label: 'Итоговая цена поступления'
  },

  price: {
    columnKey: 'cost',
    label: 'Цена'
  },

  'quantity*price': {
    columnKey: 'sum',
    label: 'На сумму'
  }
};

export const fieldMappingIncome: {
  [backendField: string]: { columnKey: string; label: string };
} = {
  'product.name': {
    columnKey: 'product_name',
    label: 'Названия товара'
  },
  'product.barcode': { columnKey: 'barcode', label: 'Штрих-код' },
  'product.ware_house.name': {
    columnKey: 'warehouse',
    label: 'Склад'
  },
  'currency.name.ru': {
    columnKey: 'currency',
    label: 'Валюта'
  },
  'product.nomenclature.measure_unit.name.ru': {
    columnKey: 'unit',
    label: 'Единица Измерения'
  },
  'legal_entity.name': {
    columnKey: 'supplier',
    label: 'Поставщик'
  },
  'category.name.ru': {
    columnKey: 'category',
    label: 'Категория'
  },
  price_in: {
    columnKey: 'purchase_price',
    label: 'Цена закуп'
  },

  quantity: { columnKey: 'quantity', label: 'Количество' },
  price: {
    columnKey: 'price_cost',
    label: 'Цена продажи'
  },

  payment_amount: {
    columnKey: 'paid',
    label: 'Оплачено'
  },

  income_amount: {
    columnKey: 'gross_income',
    label: 'Валовый доход'
  },
  date_create: {
    columnKey: 'date',
    label: 'Дата создания'
  }
};
